// import router from 'vue-router'
import axios from 'axios';
import Vue from 'vue';

function flexworkerUrl(candidateId) {
    return process.env.VUE_APP_HOUR_APP_BACKEND + '/api/flexworkers/firebase/' + encodeURIComponent(candidateId);
}

function chatUrl(chatId) {
    return process.env.VUE_APP_HOUR_APP_BACKEND + '/api/chat/' + encodeURIComponent(chatId);
}

const actions = {
    getChats: ({commit}, payload) => {
        const ApiClient = payload.ApiClient;
        const departments = payload.departments;
        const status = payload.status;

        return axios.get(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/chats', {
                params: {
                    firebaseIdToken: ApiClient.token,
                    departments: departments,
                    status: status
                }
            }
          ).then(res => {
            return res
          }).catch((err) => {
            return err
        });
    },
    getMessages: ({commit}, payload) => {
        const ApiClient = payload.ApiClient;
        const departments = payload.departments;
        const chatId = payload.chatId;

        return axios.get(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/chat/' + chatId + '/messages', {
                params: {
                    firebaseIdToken: ApiClient.token,
                    departments: departments,
                }
            }
          ).then(res => {
            return res
          }).catch((err) => {
            return err
        });
    },
    sendMessage: ({commit}, payload) => {
        const ApiClient = payload.ApiClient;
        const departments = payload.departments;
        const chatId = payload.chatId;
        const content = payload.content;
        
        return axios.post(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/chat/' + chatId + '/chat-message', 
              {
                  content: content
              },
              {
                  params: {
                      firebaseIdToken: ApiClient.token,
                      departments: departments,
                  }
              }
        ).then(res => {
            return res
        }).catch((err) => {
            return err
        });
    },
    sendFileMessage: ({commit}, payload) => {
        const ApiClient = payload.ApiClient;
        const departments = payload.departments;
        const chatId = payload.chatId;
        const file = payload.file;

        const formData = new FormData();
        formData.append('file', file);

        return axios.post(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/chat/' + chatId + '/document', 
            formData,
            {
                params: {
                    firebaseIdToken: ApiClient.token,
                    departments: departments,
                }
            }
        ).then(res => {
            return res
        }).catch((err) => {
            return err
        });
    },
    inboxArchive: ({commit}, payload) => {
        const ApiClient = payload.ApiClient;
        const departments = payload.departments;
        const chatId = payload.chatId;

        return axios.post(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/chat/' + chatId + '/inbox-archive',
            {},
            {
                params: {
                    firebaseIdToken: ApiClient.token,
                    departments: departments,
                }
            }
        ).then(res => {
            return res
        }).catch((err) => {
            return err
        });
    },
    sendCloseChatRequest: ({commit}, payload) => {
        const ApiClient = payload.ApiClient;
        const departments = payload.departments;
        const chatId = payload.chatId;

        return axios.post(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/chat/' + chatId + '/archive-ask', 
            {},
            {
                params: {
                    firebaseIdToken: ApiClient.token,
                    departments: departments,
                }
            }
        ).then(res => {
            return res
        }).catch((err) => {
            return err
        });
    },
    transferChat: ({commit}, payload) => {
        const ApiClient = payload.ApiClient;
        const departments = payload.departments;
        const chatId = payload.chatId;
        const users = payload.userIds;
        const message = payload.message;

        return axios.post(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/chat/' + chatId + '/reallocate', 
            {
                users: users,
                message: message
            },
            {
                params: {
                    firebaseIdToken: ApiClient.token,
                    departments: departments,
                }
            }
        ).then(res => {
            return res
        }).catch((err) => {
            return err
        });
    },
    getRellocateAvailability: ({commit}, payload) => {
        const ApiClient = payload.ApiClient;
        const departments = payload.departments;
        const chatId = payload.chatId;

        return axios.get(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/chat/' + chatId + '/reallocate-available', {
                params: {
                    firebaseIdToken: ApiClient.token,
                    departments: departments,
                }
            }
            ).then(res => {
                return res
            }).catch((err) => {
                return err
        });
    },
    reallocateAccept: ({commit}, payload) => {
        const ApiClient = payload.ApiClient;
        const departments = payload.departments;
        const chatId = payload.chatId;
       
        return axios.post(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/chat/' + chatId + '/reallocate/accept', {},
            {
                params: {
                    firebaseIdToken: ApiClient.token,
                    departments: departments,
                }
            }
        ).then(res => {
            return res
        }).catch((err) => {
            return err
        });
    },
    findFlexworkerByCandidateId: (context, payload) => {
        const { ApiClient, candidateId } = payload;

        return axios.get(flexworkerUrl(candidateId), {
            params: { firebaseIdToken: ApiClient.token }
        }).catch((err) => err);
    },
    getFlexworkerConversation: (context, payload) => {
        const { ApiClient, candidateId } = payload;

        return axios.get(flexworkerUrl(candidateId) + '/conversation', {
            params: { firebaseIdToken: ApiClient.token }
        }).catch((err) => err);
    },
    startFlexworkerConversation: (context, payload) => {
        const { ApiClient, candidateId, content } = payload;

        return axios.post(flexworkerUrl(candidateId) + '/conversation', { content }, {
            params: { firebaseIdToken: ApiClient.token }
        }).catch((err) => err);
    },
    claimChat: (context, payload) => {
        const { ApiClient, chatId } = payload;

        return axios.post(chatUrl(chatId) + '/claim', {}, {
            params: { firebaseIdToken: ApiClient.token }
        }).catch((err) => err);
    },
    getChatConversation: (context, payload) => {
        const { ApiClient, chatId } = payload;

        return axios.get(chatUrl(chatId) + '/conversation', {
            params: { firebaseIdToken: ApiClient.token }
        }).catch((err) => err);
    },
    getEarlierConversations: (context, payload) => {
        const { ApiClient, chatId } = payload;

        return axios.get(chatUrl(chatId) + '/earlier-conversations', {
            params: { firebaseIdToken: ApiClient.token }
        }).catch((err) => err);
    },
    markChatAsRead: ({commit}, payload) => {
        const chatId = payload.chatId;
        commit('updateChatUnreadStatus', { chatId, unread: false });
    },
}

export default actions
